export default {
  innerContainerWidth: '1056px',
};
